import { Newspaper, Construction } from 'lucide-react';
import { useDocumentTitle } from '@/shared/hooks/use-document-title';
import { NewsletterForm } from '@/features/noticias/components/newsletter-form';
import { VideosInformativos } from '@/features/noticias/components/videos-informativos';

export function NoticiasPage(): React.ReactElement {
  useDocumentTitle('Noticias');

  return (
    <main className="min-h-screen pt-20">
      {/* Hero */}
      <div className="from-primary/90 to-primary/70 text-primary-foreground relative overflow-hidden bg-linear-to-r py-20 backdrop-blur-3xl">
        <div className="absolute inset-0">
          <div className="bg-primary-foreground/10 absolute top-0 left-1/4 h-96 w-96 animate-pulse rounded-full mix-blend-overlay blur-3xl filter" />
          <div className="bg-primary-foreground/20 absolute top-1/2 right-1/4 h-80 w-80 animate-pulse rounded-full mix-blend-overlay blur-3xl filter [animation-delay:2s]" />
          <div className="bg-primary-foreground/15 absolute bottom-0 left-1/3 h-72 w-72 animate-pulse rounded-full mix-blend-overlay blur-3xl filter [animation-delay:4s]" />
        </div>

        <div className="absolute inset-0 opacity-30">
          <div className="via-primary-foreground/40 absolute top-0 left-1/4 h-full w-px bg-linear-to-b from-transparent to-transparent" />
          <div className="via-primary-foreground/30 absolute top-0 right-1/3 h-full w-px bg-linear-to-b from-transparent to-transparent" />
          <div className="via-primary-foreground/20 absolute top-1/2 left-0 h-px w-full bg-linear-to-r from-transparent to-transparent" />
        </div>

        <div className="relative z-10 container mx-auto px-4 text-center">
          <div className="border-primary-foreground/30 bg-primary-foreground/20 text-primary-foreground/90 mb-6 inline-flex items-center rounded-full border px-4 py-2 text-sm font-medium backdrop-blur-md">
            <Newspaper className="mr-2 h-4 w-4" />
            Noticias y Actualizaciones
          </div>

          <h1 className="mb-6 text-5xl leading-tight font-bold md:text-6xl lg:text-7xl">
            Mantente{' '}
            <span className="from-primary-foreground via-primary-foreground/90 to-primary-foreground/80 bg-linear-to-r bg-clip-text text-transparent">
              Informado
            </span>
          </h1>

          <p className="text-primary-foreground/80 mx-auto max-w-4xl text-xl leading-relaxed md:text-2xl">
            Descubre las últimas novedades y actividades de APEPS. Pronto encontrarás aquí las
            noticias del sector de aseguramiento en salud.
          </p>
        </div>
      </div>

      {/* Videos Informativos */}
      <VideosInformativos />

      {/* Noticias en proceso */}
      <section className="relative overflow-hidden py-8">
        <div className="from-muted/40 via-primary/5 to-primary/10 absolute inset-0 bg-linear-to-br backdrop-blur-3xl" />
        <div className="from-primary/5 to-primary/10 absolute inset-0 bg-linear-to-r via-transparent" />

        <div className="relative z-10 container mx-auto px-6 lg:px-12 xl:px-16 2xl:px-24">
          <div className="flex flex-col items-center justify-center space-y-3">
            <Construction className="text-muted-foreground/50 h-16 w-16" />
            <h2 className="text-muted-foreground text-2xl font-semibold tracking-tight">
              Noticias en proceso
            </h2>
            <p className="text-muted-foreground/70 max-w-md text-center text-sm">
              Estamos preparando esta sección. Pronto encontrarás aquí las últimas novedades de
              APEPS.
            </p>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="relative overflow-hidden pb-16">
        <div className="from-muted/40 via-primary/5 to-primary/10 absolute inset-0 bg-linear-to-br backdrop-blur-3xl" />
        <div className="from-primary/5 to-primary/10 absolute inset-0 bg-linear-to-r via-transparent" />

        <div className="relative z-10 container mx-auto px-6 lg:px-12 xl:px-16 2xl:px-24">
          <NewsletterForm />
        </div>
      </section>
    </main>
  );
}
